<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{ involved.id ? $t('involved.form.editTitle') : $t('involved.form.newTitle') }}
              </div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="col-md-12">
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="Name">
                    <span class="required">*</span> {{ $t('involved.form.nameLabel') }}
                  </label>
                  <input
                    autocomplete="new-password"
                    type="text"
                    id="Name"
                    class="form-control"
                    v-model="involved.name"
                    placeholder=""
                  />
                </div>
                <div class="form-group col-md-3">
                  <label for="SocialName"> {{ $t('involved.form.socialNameLabel') }} </label>
                  <input
                    autocomplete="new-password"
                    class="form-control"
                    id="SocialName"
                    placeholder=""
                    type="text"
                    v-model="involved.social_name"
                  />
                </div>
                <div class="form-group col-md-3">
                  <label for="Email">
                    <span class="required">*</span> {{ $t('involved.form.cpfLabel') }}
                  </label>
                  <input
                    autocomplete="new-password"
                    class="form-control"
                    id="Email"
                    placeholder=""
                    type="text"
                    v-model="involved.cpf"
                    v-mask="'999.999.999-99'"
                  />
                </div>
              </div>
              <div class="form-row">
                <div class="col-md-3">
                  <label><span class="required">*</span> {{ $t('involved.form.raceLabel') }}</label>
                  <select class="form-control" v-model="involved.race">
                    <option value="BRANCA">{{ $t('involved.form.raceWhite') }}</option>
                    <option value="PRETA">{{ $t('involved.form.raceBlack') }}</option>
                    <option value="PARDA">{{ $t('involved.form.raceBrown') }}</option>
                    <option value="AMARELA">{{ $t('involved.form.raceYellow') }}</option>
                    <option value="INDÍGENA">{{ $t('involved.form.raceIndigenous') }}</option>
                  </select>
                </div>
                <div class="form-group col-md-3">
                  <label for="EmailDomain"
                    ><span class="required">*</span> {{ $t('involved.form.rgLabel') }}</label
                  >
                  <input
                    autocomplete="new-password"
                    class="form-control"
                    id="Email"
                    placeholder=""
                    type="text"
                    v-model="involved.rg"
                    v-mask="'99.999.999-9'"
                  />
                </div>
                <div class="form-group col-md-3">
                  <label for="EmailDomain"
                    ><span class="required">*</span> {{ $t('involved.form.cnsLabel') }}</label
                  >
                  <input
                    autocomplete="new-password"
                    class="form-control"
                    id="Email"
                    type="text"
                    v-model="involved.cns"
                    placeholder=""
                  />
                </div>
                <div class="col-md-3">
                  <label><span class="required">*</span> {{ $t('involved.form.genderLabel') }}</label>
                  <select class="form-control" v-model="involved.gender">
                    <option value="M">{{ $t('involved.form.genderMale') }}</option>
                    <option value="F">{{ $t('involved.form.genderFemale') }}</option>
                    <option value="N">{{ $t('involved.form.genderNotInformed') }}</option>
                  </select>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-3">
                  <label
                    ><span class="required">*</span> {{ $t('involved.form.birthDateLabel') }}</label
                  >
                  <input
                    v-model="involved.birth_date"
                    type="date"
                    class="form-control"
                  />
                </div>
                <div class="form-group col-md-3">
                  <label> {{ $t('involved.form.telephoneLabel') }}</label>
                  <input
                    v-model="involved.telephone"
                    type="text"
                    class="form-control"
                    v-mask="'(99) 9999-9999'"
                  />
                </div>
                <div class="form-group col-md-3">
                  <label> {{ $t('involved.form.cellphoneLabel') }}</label>
                  <input
                    v-model="involved.cellphone"
                    type="text"
                    class="form-control"
                    v-mask="'(99) 99999-9999'"
                  />
                </div>
                <div class="form-group col-md-3">
                  <label for="inputUser">
                    <span class="required">*</span> {{ $t('common.status') }}:
                  </label>
                  <select v-model="involved.status" class="form-control">
                    <option :value="1">{{ $t('common.active') }}</option>
                    <option :value="0">{{ $t('common.inactive') }}</option>
                  </select>
                </div>
              </div>
              <span class="required_fields">
                <span class="required">*</span>
                <strong>{{ $t('involved.form.requiredFields') }}</strong>
              </span>
              <div class="block text-right mb-1">
                <router-link to="/involveds" class="btn btn-back">
                  <i class="fa fa-arrow-left"></i> {{ $t('common.back') }}
                </router-link>
                <a v-if="$hasAbility('envolvido.gerenciar')" class="btn btn-add ml-1" @click="save">
                  {{ $t('common.save') }}
                  <i class="fa fa-save"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import Loading from "vue-loading-overlay";

export default {
  name: "imageUpload",
  data() {
    return {
      involved: {
        name: "",
        social_name: "",
        cpf: "",
        rg: "",
        cns: "",
        gender: "",
        birth_date: "",
        race: "",
        telephone: "",
        cellphone: "",
        status: "1",
      },
    };
  },
  computed: {},
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "involveds";

      if (self.involved.id) {
        api += "/" + self.involved.id;
        self.involved._method = "PUT";
      }

      self.$loading(true);

      self.$http
        .post(api, self.involved)
        .then((response) => {
          self.$message(
            self.$t('involved.messages.successTitle'),
            self.$t('involved.messages.saveSuccess'),
            "success"
          );
          self.$loading(false);
          this.$router.push("/involveds");
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    getInvolved: function (id) {
      const self = this;
      const api = self.$store.state.api + "involveds/" + id;
      self.$loading(true);

      self.$http
        .get(api)
        .then((response) => {
          self.involved = response.data.data[0];
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    if (id) {
      self.getInvolved(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
    Loading,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>